/* tslint:disable */
/* eslint-disable */
/**
 * Registration App Tier Micro Service APIs
 * Registration App Tier Micro Service APIs
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MinorDocument
 */
export interface MinorDocument {
    /**
     * 
     * @type {string}
     * @memberof MinorDocument
     */
    recordType: MinorDocumentRecordTypeEnum;
    /**
     * base64 encoded image data for validation or uploading.
     * @type {string}
     * @memberof MinorDocument
     */
    documentData: string;
    /**
     * the mime type of the documentData
     * @type {string}
     * @memberof MinorDocument
     */
    documentMimeType?: string;
    /**
     * 
     * @type {Date}
     * @memberof MinorDocument
     */
    expiryDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MinorDocument
     */
    issueDate?: Date;
}


/**
 * @export
 */
export const MinorDocumentRecordTypeEnum = {
    ParentCid: 'PARENT_CID',
    HouseRegistration: 'HOUSE_REGISTRATION',
    ParentSign: 'PARENT_SIGN'
} as const;
export type MinorDocumentRecordTypeEnum = typeof MinorDocumentRecordTypeEnum[keyof typeof MinorDocumentRecordTypeEnum];


/**
 * Check if a given object implements the MinorDocument interface.
 */
export function instanceOfMinorDocument(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recordType" in value;
    isInstance = isInstance && "documentData" in value;

    return isInstance;
}

export function MinorDocumentFromJSON(json: any): MinorDocument {
    return MinorDocumentFromJSONTyped(json, false);
}

export function MinorDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): MinorDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recordType': json['recordType'],
        'documentData': json['documentData'],
        'documentMimeType': !exists(json, 'documentMimeType') ? undefined : json['documentMimeType'],
        'expiryDate': !exists(json, 'expiryDate') ? undefined : (new Date(json['expiryDate'])),
        'issueDate': !exists(json, 'issueDate') ? undefined : (new Date(json['issueDate'])),
    };
}

export function MinorDocumentToJSON(value?: MinorDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recordType': value.recordType,
        'documentData': value.documentData,
        'documentMimeType': value.documentMimeType,
        'expiryDate': value.expiryDate === undefined ? undefined : (value.expiryDate.toISOString()),
        'issueDate': value.issueDate === undefined ? undefined : (value.issueDate.toISOString()),
    };
}

